import { Provider } from '@angular/core';
import { forwardRef } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { graphqlClientService } from './graphqlClient.service';

export interface IGraphqlClientService extends graphqlClientService {}

/**@deprecated use graphqlClientService instead */
export const GraphqlClientServiceToken = new InjectionToken<IGraphqlClientService>('GraphqlClientService');

export const GraphqlClientServiceProvider: Provider = {
	provide: GraphqlClientServiceToken,
	useExisting: forwardRef(() => graphqlClientService)
};